"use client";
import React, { useEffect, useState } from "react";

export const BottomIcon = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 100);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`topArrowAlignment ${
        isVisible ? "visible" : ""
      } scroll-smooth`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <div className="back-to-top">
        <svg
          className="back-to-top-icon"
          width="24px"
          height="69px"
          viewBox="0 0 24 69"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(2.000000, 2.000000)">
              <rect
                fill="currentColor"
                x="9"
                y="7"
                width="2"
                height="60"
              ></rect>
              <polygon
                stroke="currentColor"
                strokeWidth="2"
                points="10 0 20 13 0 13"
              ></polygon>
            </g>
          </g>
        </svg>
        <p className="back-to-top-text">TOP</p>
      </div>
    </div>
  );
};
